import { MARKET_CONFIG } from "../nerdlets/home/contexts/MarketContext";

/**
 * The market the panel is looking at, from the URL.
 *
 * Not from the entity: stores are often opened against a fallback dashboard
 * guid whose account is CH whichever market is in view, so the guid cannot be
 * trusted to name the market or its account.
 *
 * MARKET_CONFIG rather than ACCOUNT_CODES because the account id has to be
 * exact here — NerdGraph searches are rejected unless scoped to a permitted
 * account ("Entity search must be scoped to a permitted account id"), and
 * ACCOUNT_CODES maps two different ids to CH, so reversing it is a coin flip.
 */
export function currentMarket() {
  if (typeof window === "undefined") return null;
  const code = new URLSearchParams(window.location.search).get("market");
  const config = code ? MARKET_CONFIG[code] : null;
  return config ? { code, accountId: config.accountId } : null;
}
